import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialCustomersState } from './initialState'
import { CustomersState, UserListCustomer } from './types'

const slice = createSlice({
  name: 'userLists/customers',
  initialState: initialCustomersState,
  reducers: {
    setCustomers: (
      state,
      action: PayloadAction<{
        userListId: number
        customers: UserListCustomer[]
        totalCount: number
        pagination: CustomersState['pagination'][number]
      }>
    ) => {
      const { userListId, customers, totalCount, pagination } = action.payload
      state.entries[userListId] = customers
      state.totalCount[userListId] = totalCount
      state.pagination[userListId] = pagination
    },
    setCustomersSearchQuery: (
      state,
      action: PayloadAction<{ userListId: number; query: string }>
    ) => {
      const { userListId, query } = action.payload
      state.searchQuery[userListId] = query
    },
  },
})

export const reducer = slice.reducer
export const { setCustomers, setCustomersSearchQuery } = slice.actions

type UserListsRootState = {
  userLists: { customers: ReturnType<typeof reducer> }
}

export const selectCustomersByListId = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.customers.entries[userListId] || []

export const selectCustomersTotalCount = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.customers.totalCount[userListId] || 0

export const selectCustomersSearchQuery = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.customers.searchQuery[userListId] || ''

export const selectCustomersPagination = (
  state: UserListsRootState,
  userListId: number
) => state.userLists.customers.pagination[userListId] || null

export type { UserListCustomer, CustomersState } from './types'
